import { render, staticRenderFns } from "./ScreenSwiper.vue?vue&type=template&id=f97a44f2&scoped=true&"
import script from "./ScreenSwiper.vue?vue&type=script&lang=js&"
export * from "./ScreenSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ScreenSwiper.vue?vue&type=style&index=0&id=f97a44f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97a44f2",
  null
  
)

export default component.exports